import ManageSubscription from 'components/ManageSubscription/ManageSubscription';

export default ManageSubscription;
